import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d5fd3c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leftTopit" }
const _hoisted_2 = {
  key: 0,
  class: "box"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "单选题", -1))
const _hoisted_4 = { class: "items" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "icon"
}
const _hoisted_8 = {
  key: 1,
  class: "box"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "多选题", -1))
const _hoisted_10 = { class: "items" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "icon"
}
const _hoisted_14 = {
  key: 2,
  class: "box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "判断题", -1))
const _hoisted_16 = { class: "items" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.examQuestionList.radioList?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examQuestionList.radioList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.sort,
                style: _normalizeStyle(`margin-right:${index % 6 === 5 ? 0 : 15}px`)
              }, [
                _createElementVNode("div", {
                  class: "top",
                  onClick: ($event: any) => (_ctx.clickExam(item, index, 'radioList')),
                  style: _normalizeStyle(_ctx.examItemStyle(item))
                }, _toDisplayString(item.sort + 1), 13, _hoisted_5),
                _createElementVNode("div", {
                  class: "bottom",
                  onClick: ($event: any) => (_ctx.sign(index))
                }, [
                  (item.isSign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_6)
              ], 4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.examQuestionList.multiList?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examQuestionList.multiList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.sort,
                style: _normalizeStyle(`margin-right:${index % 6 === 5 ? 0 : 15}px`)
              }, [
                _createElementVNode("div", {
                  class: "top",
                  onClick: ($event: any) => (_ctx.clickExam(item, index, 'multiList')),
                  style: _normalizeStyle(_ctx.examItemStyle(item))
                }, _toDisplayString(item.sort + 1), 13, _hoisted_11),
                _createElementVNode("div", {
                  class: "bottom",
                  onClick: ($event: any) => (_ctx.sign2(index))
                }, [
                  (item.isSign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_12)
              ], 4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.examQuestionList.judgeList?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.examQuestionList.judgeList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.sort,
                style: _normalizeStyle(`margin-right:${index % 6 === 5 ? 0 : 15}px`)
              }, [
                _createElementVNode("div", {
                  class: "top",
                  onClick: ($event: any) => (_ctx.clickExam(item, index, 'judgeList')),
                  style: _normalizeStyle(_ctx.examItemStyle(item))
                }, _toDisplayString(item.sort + 1), 13, _hoisted_17),
                _createElementVNode("div", {
                  class: "bottom",
                  onClick: ($event: any) => (_ctx.sign3(index))
                }, [
                  (item.isSign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_18)
              ], 4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}